import { render, staticRenderFns } from "./department-process-datasource-datasubject-view.vue?vue&type=template&id=0c70e124"
import script from "./department-process-datasource-datasubject-view.vue?vue&type=script&lang=js"
export * from "./department-process-datasource-datasubject-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports